import { Component, OnInit } from '@angular/core';
import { BnplService } from './feature/BNPL/shared/services/bnpl.service';
import { environment } from 'src/environments/environment';
import { NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  urlImg: string = environment.urlAwsImg;

  routes: string[] = [
    '/',
    '/personal-information',
    '/selection-fees',
    '/confirm-otp',
  ];

  constructor(private bnplService: BnplService, private router: Router) {}

  ngOnInit(): void {
    this.onReloadDetected();
    this.onNavigateBackToFront();
    /**WAKE UP */
    this.bnplService.wakeUpIdVal();
    this.bnplService.wakeUpAuthentic();
    this.bnplService.wakeUpCreatePdf();
    this.bnplService.wakeUpSendEmail();
    // this.bnplService.wakeUpDruo()
    this.bnplService.wakeBigQuery();
  }

  onReloadDetected(): void {
    const wasReloaded = performance?.navigation?.type === 1;

    if (wasReloaded) {
      window.location.href = '/';
    }
  }

  onNavigateBackToFront() {
    this.router.events.subscribe((event) => {
      if (
        event instanceof NavigationStart &&
        event.navigationTrigger === 'popstate'
      ) {
        this.router.navigate(['/']);
      }
    });
  }

  getErrorMessage(fieldFormGroup: any) {
    const ERROR = fieldFormGroup.errors;
    let message = '';

    if (ERROR['required']) {
      message = 'Campo Obligatorio';
    } else if (ERROR['email']) {
      message = 'Debe ingresar una dirección de email válida';
    } else if (ERROR['minlength'] || ERROR['maxlength'] || ERROR['pattern']) {
      message = 'Valor inválido';
    }
    return message;
  }
}
